import { ArrowDownRight, ArrowUpRight } from "lucide-react";
import { cn } from '../../lib/utils';
const accents = {
  primary: "text-primary",
  chart1: "text-chart-1",
  chart2: "text-chart-2",
  chart3: "text-chart-3"
};
function KpiCard({
  label,
  value,
  hint,
  variacao,
  icon: Icon,
  accent = "primary"
}) {
  const positivo = (variacao ?? 0) >= 0;
  return <div className="group relative overflow-hidden rounded-lg border border-border bg-card p-4 transition-colors hover:border-ring/60">
      <div className="flex items-start justify-between gap-3">
        <div className="min-w-0">
          <p className="text-[9px] font-bold uppercase tracking-[0.18em] text-muted-foreground">
            {label}
          </p>
          <p className="mt-2 truncate font-mono text-2xl font-black text-foreground">
            {value}
          </p>
          {hint ? <p className="mt-1 truncate text-[10px] text-muted-foreground">{hint}</p> : null}
        </div>
        <Icon className={cn("shrink-0 opacity-70", accents[accent])} size={22} />
      </div>

      {variacao !== void 0 ? <div
    className={cn(
      "mt-3 inline-flex items-center gap-1 rounded px-1.5 py-0.5 font-mono text-[10px] font-bold",
      positivo ? "bg-chart-2/15 text-chart-2" : "bg-destructive/15 text-destructive"
    )}
  >
          {positivo ? <ArrowUpRight size={11} /> : <ArrowDownRight size={11} />}
          {`${positivo ? "+" : ""}${variacao.toFixed(1)}% vs ano anterior`}
        </div> : null}

      <div className="pointer-events-none absolute -right-8 -top-8 h-20 w-20 rounded-full bg-primary/10 blur-2xl transition-opacity group-hover:opacity-100 md:opacity-60" />
    </div>;
}
export {
  KpiCard
};
